import { provideWidgetClass } from "scrivito"

export const DataEmptyWidget = provideWidgetClass("DataEmptyWidget", {
  attributes: {
    content: "widgetlist"
  }
})
